import type React from "react";
import { DocumentLayout } from "~/components/Layout";
import "./style.css";

export const TermsJapanese: React.FC = () => (
	<DocumentLayout>
		<main className="document-main-content document-ja">
			<h1 className="document-h1 mb-14">Web.Auto利用規約</h1>
			<div className="col-10 mx-auto">
				<p>
					本規約は、本サービス（第2条で定義します。）の提供と利用に関する条件を定めるものです。申請者がユーザーとして登録される前に、本規約のすべてを読み、それに同意する必要があります。
				</p>

				<h2 className="document-h2 mt-12">第1章 目的と定義</h2>
				<article className="mb-8">
					<h3 className="my-4">
						第1条 <span className="text-decoration-underline">目的</span>
					</h3>
					<p>
						本規約は、本サービスを提供及び利用するための条件、並びに本サービスに関連する当社及びユーザーの権利義務を規定することを目的とします。本規約は、あらゆる局面における本サービスに関連する当社とユーザーとの間の関係に適用されるものとします。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第2条 <span className="text-decoration-underline">定義</span>
					</h3>
					<p>本規約において、以下の用語は以下の意味を有するものとします。</p>
					<ol className="list-parentheses">
						<li>
							「アカウント」とは、「TIER IV
							Account」の名称で当社がユーザーに対して付与する、本サービスを利用するためのアカウントを意味します。
						</li>
						<li>
							「反社会的勢力」とは、第3条第3項第3号に定める意味を有します。
						</li>
						<li>「申請者」とは、第3条第1項に定める意味を有します。</li>
						<li>「拒否事由」とは、第3条第3項各号に定める事項を意味します。</li>
						<li>「当社」とは、株式会社ティアフォーを意味します。</li>
						<li>
							「被補償当社関連当事者」とは、第12条第4項に定める意味を有します。
						</li>
						<li>
							「コンテンツ」とは、動画、静止画、音声、テキスト、グラフィック、ロゴ、ボタンアイコン、文字その他一切のデータをいいます。
						</li>
						<li>「無償機能」とは、第4条第1項に定める意味を有します。</li>
						<li>
							「連携ツール」とは、本サービスと連携させることにより、本システム上で利用可能になるツールのことをいいます。
						</li>
						<li>
							「知的財産権」とは、あらゆる国における著作権、特許権、商標権、実用新案権、意匠権、及びその他の知的財産権（かかる権利を取得する、又はその登録の申請を行う権利を含みます。）を意味します。
						</li>
						<li>「有償機能」とは、第4条第2項に定める意味を有します。</li>
						<li>
							「有償機能ライセンス契約」とは、第4条第2項に定める意味を有します。
						</li>
						<li>「パスワード」とは、第5条第1項に定める意味を有します。</li>
						<li>
							「者」とは、個人、会社及びその他のエンティティ（独立の法人格を有するか否かにかかわりません。）を含むあらゆる者を意味します。
						</li>
						<li>
							「プライバシーポリシー」とは、第15条第1項に定める意味を有します。
						</li>
						<li>「登録情報」とは、第3条第1項に定める意味を有します。</li>
						<li>「本規則」とは、第7条第1号に定める意味を有します。</li>
						<li>
							「本サービス」とは、当社が本システム（以下で定義します。）上で提供する、自動運転システムの開発、運行管理等を行うためのクラウドサービスであるWeb.Autoをいいます。
						</li>
						<li>
							「本システム」とは、当社が運営・管理するシステムのことをいいます。
						</li>
						<li>
							「ユーザー」とは、第3条に従ってサービスのユーザーとして登録された者を意味します。
						</li>
						<li>
							「ユーザーデータ」とは、ユーザーが本サービスを利用してクラウド上にアップロードしたコンテンツその他のデータをいいます。
						</li>
						<li>「ユーザーID」とは、第5条第1項に定める意味を有します。</li>
						<li>
							「本ウェブサイト」とは、本サービスに関連する当社のウェブサイトを意味します。
						</li>
					</ol>
				</article>

				<h2 className="document-h2 mt-12">第2章 ユーザー</h2>
				<article className="mb-8">
					<h3 className="my-4">
						第3条{" "}
						<span className="text-decoration-underline">アカウント登録</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							本サービスの利用を希望する者は、本サービスを利用するためのアカウントの登録を申請し、当社が指定するフォームにより特定の情報（以下「登録情報」といいます。）を提供するものとします。かかる申請を行う者（以下「申請者」といいます。）は、本規約に従うことに同意したものとみなされます。
						</li>
						<li>
							申請者のアカウントの登録は、当社が要求する登録手続きを全て履行した時点で完了し、申請者はアカウントの登録が完了した時点で、ユーザーとして本規約に従って本サービスの利用を開始することができます。別途合意しない限り、申請者には、本サービスへのアクセスに使用するアカウントが1つのみ付与されます。
						</li>
						<li>
							当社は、理由を開示することなく、いかなる理由でも申請者の申請又は登録を拒否することができます。とりわけ、当社は、以下の場合に登録を拒否することができます。
							<ol className="list-sub-parentheses">
								<li>
									申請者から当社に提供された登録情報のいずれかが、虚偽、不正確、誤解を招くおそれがあり、又は省略されている場合
								</li>
								<li>
									申請者が未成年者、成年被後見人、被保佐人若しくは被補助人、又は何らかの法令により行為能力が制限されているその他の個人である場合（ただし、かかる申請者の法定代理人の必要な同意が正当に得られた場合を除きます。）
								</li>
								<li>
									申請者が（i）暴力団若しくは暴力団員、極右団体、その他の反社会的勢力（以下、総称して「反社会的勢力」といいます。）である場合、（ii）反社会的勢力と何らかの交流若しくは関与がある場合、又は（iii）資金調達若しくはその他の手段により反社会的勢力の維持、運営若しくは管理の支援若しくはそれらに関与している場合
								</li>
								<li>
									申請者の申請または登録が、当社によって以前に解除された場合
								</li>
							</ol>
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第4条 <span className="text-decoration-underline">利用料</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							ユーザーは、当社が無償機能として別途指定する機能（以下「無償機能」といいます。）を、本規定に従い自由に利用できるものとします。無償機能の利用料は無償とします。
						</li>
						<li>
							ユーザーが、当社との間で別途ライセンス契約（以下「有償機能ライセンス契約」といいます。）を締結した場合には、当社が有償機能として別途指定する機能（以下「有償機能」といいます。）を、利用できるものとします。有償機能の利用料は、有償機能ライセンス契約において定めるものとします。
						</li>
					</ol>
				</article>

				<h2 className="document-h2 mt-12">第3章 ユーザーの誓約</h2>
				<article className="mb-8">
					<h3 className="my-4">
						第5条{" "}
						<span className="text-decoration-underline">
							ユーザーIDとパスワード
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社は、第3条に基づくアカウント登録の完了時に、各ユーザーにユーザーID（以下「ユーザーID」といいます。）を提供するものとします。ユーザーは、ユーザーが指定する本サービスを利用するためのパスワード（以下「パスワード」といいます。）とともに、ユーザーIDを秘密として、また適切な方法で、保管及び管理する責任を負います。
						</li>
						<li>
							ユーザーは、ユーザーID又はパスワードを第三者に開示し、又は第三者によるそれらの利用を許可してはなりません。ユーザーID又はパスワードが利用された場合、当社は、ユーザーがそれを利用したとみなすことができます。当社は、ユーザーによるユーザーID若しくはパスワードの不適切な保管若しくは利用、又は第三者によるそれらの誤用によって発生した、又はそれらに関連して発生したいかなる損害、損失、費用又は経費についてもユーザーに対して責任を負いません。
						</li>
						<li>
							ユーザーは、同じアカウントを使用して、同時に複数のコンピューター又は他の装置から本サービスにアクセスしてはなりません。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第6条{" "}
						<span className="text-decoration-underline">登録情報の変更</span>
					</h3>
					<p>
						ユーザーは、当社が指定する方法で登録情報の変更を当社に速やかに通知するものとします。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第7条{" "}
						<span className="text-decoration-underline">ユーザーの義務</span>
					</h3>
					<p>ユーザーは、以下の義務を遵守しなければなりません。</p>
					<ol className="list-parentheses">
						<li>
							すべての関連する法域で適用されるすべての法令（個人情報に関連するものを含みます。）、本規約、及び当社が定める本サービスの利用に関するその他規則（以下「本規則」といいます。）を遵守すること。
						</li>
						<li>
							当社、他のユーザー又は第三者の知的財産権、肖像権、プライバシー権、評判又はその他の権利を侵害しないこと。
						</li>
						<li>
							犯罪（詐欺及び脅迫を含みます。）や公序や倫理的価値観に反する行為をしないこと。
						</li>
						<li>
							他のユーザーのユーザーID又はパスワードを使用したり、本サービスのシステム又はネットワークに不正にアクセスし、又はアクセスを試みたりしないこと。
						</li>
						<li>
							連携ツールを利用する場合には、連携ツールの利用規約及び連携ツールの利用に関するその他規則を遵守すること。
						</li>
						<li>
							有償機能を利用する場合には、有償機能ライセンス契約の規定を遵守すること。
						</li>
						<li>
							本サービスの複製、翻案等の改変、又は公衆送信を行わないこと。
						</li>
						<li>本サービスの利用権の販売または再使用許諾を行わないこと。</li>
						<li>
							本サービスの一部又は全部のリバースエンジニアリング、逆コンパイル若しくは逆アセンブルを行い、又はその他の方法でソースコードを抽出する方法等により本サービスを解析しないこと。
						</li>
						<li>
							次のものを投稿、アップロード又は送信しないこと。
							<ol className="list-decimal-without-dot">
								<li>
									コンピュータウイルス又はその他危険なコンピュータプログラム
								</li>
								<li>第三者の個人情報又はデータを含むコンテンツ</li>
								<li>
									当社、他のユーザー又は第三者の名声や信用を傷つける可能性のあるコンテンツ
								</li>
								<li>
									暴力的、残酷、性的、卑猥若しくは反社会的な性質を有するコンテンツ、又は犯罪若しくは差別を助長するコンテンツ
								</li>
								<li>広告、勧誘又はマーケティングに該当するコンテンツ</li>
							</ol>
						</li>
						<li>
							本サービスのネットワーク又はシステムに過度の負担をかけたり、その他本サービスの運営を妨げたりしないこと。
						</li>
						<li>当社が不適切と合理的にみなすその他行為をしないこと。</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第8条{" "}
						<span className="text-decoration-underline">
							知的財産権とユーザーにより本ウェブサイトに投稿されたコンテンツ
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							本ウェブサイト及び本サービスに関連するすべての知的財産権は、当社又はそのライセンサーに明示的に留保されています。本規約に含まれているいかなる条項も、本規約に定める範囲を超えてユーザーが本サービスを利用することについて、当社又はそのライセンサーが保有する知的財産権のユーザーへのライセンスの付与を意味するものではありません。
						</li>
						<li>
							前項の規定にかかわらず、ユーザーデータの知的財産権は、当該ユーザーデータをアップロードしたユーザーまたは当該ユーザーに権利を許諾する第三者に帰属するものとします。当社は、本サービスを提供するために必要な限度で、ユーザーデータを当社が管理するサーバーに保管しまたは利用することができるものとし、ユーザーは、かかる保管または利用に必要な限度で、ユーザーデータの非独占的なライセンスを当社に付与するものとします。
						</li>
						<li>
							当社は、ユーザーの本サービスの利用状況（ユーザーデータを含みます。）を分析し、統計化した上で、本サービスの運営、改善、営業、マーケティング及び当社の新サービスの開発に利用することができるものとします。
						</li>
					</ol>
				</article>

				<h2 className="document-h2 mt-12">第4章 停止、解除、撤回及び変更</h2>
				<article className="mb-8">
					<h3 className="my-4">
						第9条{" "}
						<span className="text-decoration-underline">本サービスの停止</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社は、以下の場合に、当社が必要と判断する期間、ユーザーへの通知なしに、本サービスの全部又は一部を一時的に停止又は中止する権利を有します。
							<ol className="list-sub-parentheses">
								<li>
									緊急又は不可避の事情により、本サービスに使用されるコンピューターシステムの点検又はメンテナンスが必要な場合
								</li>
								<li>
									事故又はその他の予期せぬ出来事のために、コンピューター又は通信回線が中断されている場合
								</li>
								<li>
									不可抗力（地震、落雷、火災、風水害、停電その他の自然災害を含みますがこれらに限定されません。）により、当社が本サービスを提供することができない場合
								</li>
								<li>
									その他の理由により、当社が停止又は中止が必要であると合理的に判断する場合
								</li>
							</ol>
						</li>
						<li>
							本条に基づき当社が講じた措置から発生した、ユーザーが被ったいかなる損害についても、当社は一切責任を負いません。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第10条 <span className="text-decoration-underline">登録解除</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							ユーザーは、当社に通知することその他当社の定める方法により、ユーザーとしての登録をいつでも解除することができます。
						</li>
						<li>
							以下のいずれかの場合には、当社は、通知又は催告することなく、ユーザーによる本サービスの使用を一時的に停止し、又はユーザーとしての登録を解除することができます。
							<ol className="list-sub-parentheses">
								<li>ユーザーが本規約の規定に違反した場合</li>
								<li>
									ユーザーがユーザーの登録時又はそれ以降に拒否事由に該当する場合
								</li>
								<li>ユーザーが12ヶ月以上本サービスを利用していない場合</li>
								<li>
									ユーザーが、30日以内に当社からの合理的な問い合わせ、又はその他の要求に応じない場合
								</li>
							</ol>
						</li>
						<li>
							ユーザーは、ユーザーの登録の解除、又はユーザーによる本サービスの使用の停止以降、本サービスを用いてユーザーデータを閲覧することはできません。ユーザーは自己の責任でユーザーデータをバックアップする等必要な手段を取るものとします。
						</li>
						<li>
							当社は、いかなる状況においても、ユーザーの登録の解除又はユーザーによる本サービスの使用の停止に起因する、又はそれらに関連して発生した、ユーザーが被ったいかなる損害についても責任を負いません。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第11条{" "}
						<span className="text-decoration-underline">
							本サービスの変更と終了
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社は、その独自の裁量により、いつでも本サービスを変更又は終了する権利を有します。当社は、本サービスの想定される変更又は終了を事前にユーザーに通知するために合理的な努力を行うものとします。
						</li>
						<li>
							当社は、当社による本サービスの変更又は終了によって、又はそれに関連してユーザーが被ったいかなる損害についても責任を負いません。
						</li>
					</ol>
				</article>

				<h2 className="document-h2 mt-12">第5章 雑則</h2>
				<article className="mb-8">
					<h3 className="my-4">
						第12条{" "}
						<span className="text-decoration-underline">
							保証の免責及び放棄
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社は、本サービスに関するいかなる明示的又は黙示的な表明保証も行いません。かかる表明保証には、（i）ユーザーが考慮した特定の目的への妥当性又は適合性、（ii）本サービスに期待される機能、商業的価値、正確性又は有用性、（iii）本サービスのユーザーによる利用が、ユーザーに適用される法令又は業界団体によって確立された内部規則を遵守していること、（iv）本サービスに中断又は欠陥がないこと、（v）第三者の権利を侵害していないこと、（vi）本サービス、そのサーバー、当社が送信した電子メールにウイルスその他危険なコンピュータプログラムが含まれていないこと、並びに（vii）本サービス及び本ウェブサイトの内容の正確性に関する表明保証が含まれますが、これらに限定されません。
						</li>
						<li>
							当社に帰責性のある何らかの理由によりユーザーが被った損害に関して、いかなる状況においても、当社は、付随的損害、間接的損害、特別損害若しくは将来の損害又は逸失利益に関する責任を負いません。
						</li>
						<li>
							当社は、本サービス又は本ウェブサイトに関連して、ユーザーと他のユーザー又は第三者との間の取引、通信又は紛争について一切責任を負いません。
						</li>
						<li>
							ユーザーは、本サービス又は本ウェブサイトのコンテンツの利用に関するすべての責任を負います。損害賠償請求などの第三者との民事訴訟、又はさらに刑事事件においてユーザーの責任が認められた場合でも、当社、その子会社及びその他の関連会社、並びにそれらの取締役、役員、従業員及び代理人（以下、総称して「被補償当社関連当事者」といいます。）は、ユーザーが被補償当社関連当事者に対して有する権利若しくは主張、又はあらゆる法的行為、訴訟若しくは類似の手続きから完全に免責されます。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第13条 <span className="text-decoration-underline">補償</span>
					</h3>
					<p>
						ユーザーは、ユーザーによる本契約の規定（表明保証を含みます。）の違反若しくは適用法令の違反、又はユーザーによる本サービス若しくは本ウェブサイトのコンテンツの利用を原因とする、又はそれらから、若しくはそれらに関連して発生する被補償当社関連当事者の損害、損失、責任、費用若しくは経費（弁護士費用を含みます。）、又は第三者による被補償当社関連当事者に対するいかなる請求又は要求について、被補償当社関連当事者に補償し、被補償当社関連当事者が責任を負わないようにします。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第14条 <span className="text-decoration-underline">守秘義務</span>
					</h3>
					<p>
						ユーザーが当社の書面による事前の同意を得ない限り、ユーザーは、本サービスに関連して当社がユーザーに開示した一切の非公開情報を秘密として管理しなければなりません。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第15条{" "}
						<span className="text-decoration-underline">ユーザーの情報</span>
					</h3>
					<p>
						当社は、当社が別途定めるプライバシーポリシー（以下「プライバシーポリシー」といいます。）に従って、ユーザー又は元ユーザーの情報を管理し、使用します。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第16条{" "}
						<span className="text-decoration-underline">
							本規約の変更と本規則
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社は、以下各号の場合には、ユーザーの事前の同意を得ることなく、本規約をいつでも変更することができ、その場合には、ユーザーはこれに同意したものとみなされます。
							<ol className="list-sub-parentheses">
								<li>本規約の変更が、ユーザーの一般の利益に適合するとき</li>
								<li>
									本規約の変更が、本規約の目的に反せず、かつ、変更の必要性及び変更後の内容の相当性を含む変更に係る事情に照らして合理的なものであるとき
								</li>
							</ol>
						</li>
						<li>
							当社は、前項の規定により本規約を変更するときは、変更の効力発生日までに、本規約を変更する旨、変更の内容及びその効力発生日をユーザーに本ウェブサイト上で、又は第17条に従って通知します。
						</li>
						<li>
							本規則、又は当社とユーザーとの間の本サービスに関する他の契約（もしあれば）において別段の定めがない限り、本規約と本規則又はかかる契約との間に矛盾がある場合には、本規約が優先するものとします。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第17条 <span className="text-decoration-underline">通知</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							当社が別途指定しない限り、ユーザーから当社へのすべての通知及びその他の連絡（本サービスに関する問い合わせを含みます。）は、当社が指定する電子メールアドレスへの電子メールの送付により、又は本ウェブサイトに設けられているフォームにより、行われます。
						</li>
						<li>
							本規約に別段の定めがない限り、当社からユーザーへのすべての通知及びその他の連絡は、電子メールにより行われるものとします。当社がユーザーの登録情報に含まれる電子メールアドレスに電子メールで通知又は連絡を送信した場合、ユーザーは、実際にそれを受信したかどうかにかかわらず、直ちにその通知又は通信を受信したとみなされます。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第18条 <span className="text-decoration-underline">譲渡</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>
							ユーザーは、当社の書面による事前の同意なしに、本規約上の地位又は権利義務につき、第三者に対し、譲渡、移転、担保権の設定、その他の処分をしてはなりません。
						</li>
						<li>
							当社が本サービスに関する事業を第三者に譲渡する場合には、当社は、当該事業譲渡の一環として、本規約上の地位及び権利義務並びに登録情報及びユーザーに関連するその他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーはかかる譲渡にあらかじめ同意します。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第19条 <span className="text-decoration-underline">分離可能性</span>
					</h3>
					<p>
						本規約のいずれかの規定又はその一部が、日本法又はその他の法域の法により無効又は執行不能と判断された場合であっても、本規約のその他規定は完全に効力を有するものとします。
					</p>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第20条{" "}
						<span className="text-decoration-underline">
							準拠法及び裁判管轄
						</span>
					</h3>
					<ol className="list-decimal pl-6">
						<li>本規約の準拠法は、日本法とします。</li>
						<li>
							本規約に起因し、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
						</li>
					</ol>
				</article>

				<article className="mb-8">
					<h3 className="my-4">
						第21条 <span className="text-decoration-underline">言語</span>
					</h3>
					<p>
						英語を本規約の正文とします。本規約の他の言語への翻訳は、参照目的でのみ作成されるものであり、いかなる当事者も拘束するものでもありません。
					</p>
				</article>

				<p>2023年2月28日 制定</p>
			</div>
		</main>
	</DocumentLayout>
);
